import { State } from './types';

const initialState: State = {
  list: {
    isLoading: false,
    data: [],
    error: null,
  },
  add: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: null,
    data: {},
  },
  duplicate: {
    isLoading: false,
    error: null,
  },
  info: {
    isLoading: false,
    error: null,
    data: {},
  },
  update: {
    isLoading: false,
    error: null,
  },
};

export default initialState;
